import ReactSelect from '../baseInputs/react-select'

type Obj = {
  name: string
}

type Props = {
  models: Array<Obj>
  helper?: string
  optional?: boolean
}

const MultiSelectModels = ({ models, ...rest }: Props) => {
  const name = 'model'
  const label = 'Models of interest'

  const options = models.map((model) => {
    return {
      label: model.name,
      value: model.d4t4.id,
    }
  })

  return (
    <ReactSelect
      isMulti
      name={name}
      label={label}
      options={options}
      {...rest}
    />
  )
}

export default MultiSelectModels
